import React, { useEffect, useState } from "react";
import { FaSistrix } from "react-icons/fa";
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";
import BreadcrumbOne from "../../elements/breadcrumb/BreadcrumbOne";
import BlogProp from "./itemProp/BlogProp";
import SideCategories from "./sidebar/SideCategories";
import SidebarTag from "./sidebar/SidebarTag";
import axios from "axios";

const BlogGridSidebar = () => {
  const cachedContents = localStorage.getItem("contents");
  const [contents, setContents] = useState(cachedContents ? JSON.parse(cachedContents) : []);
  const [loading, setLoading] = useState(!cachedContents);
  const [checkingAccess, setCheckingAccess] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const customerId = storedUser?.id || null;

  useEffect(() => {
    const token = localStorage.getItem("token");
    const cachedAt = localStorage.getItem("contents_updated_at");

    const isCacheExpired = () => {
      if (!cachedAt) return true;
      const now = Date.now();
      const expiry = 60 * 60 * 1000; // 1 hour
      return now - parseInt(cachedAt) > expiry;
    };

    const fetchContents = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/contents`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        if (!res.ok) throw new Error("API error");
        const data = await res.json();

        if (JSON.stringify(data) !== JSON.stringify(contents)) {
          setContents(data);
          localStorage.setItem("contents", JSON.stringify(data));
          localStorage.setItem("contents_updated_at", Date.now().toString());
        }
      } catch (err) {
        console.error("Error fetching contents:", err);
      }
    };

    const checkAccess = async () => {
      if (!customerId) {
        setHasAccess(false);
        setCheckingAccess(false);
        return;
      }

      try {
        const res = await axios.get(`${API_BASE_URL}/user/content-access`, {
          params: { customer_id: customerId },
        });

        const orders = res.data || [];
        const validAccess = orders.some((order) => order.remaining_days > 0);
        setHasAccess(validAccess);
      } catch (err) {
        console.error("Error checking access:", err);
        setHasAccess(false);
      } finally {
        setCheckingAccess(false);
      }
    };

    if (!cachedContents || isCacheExpired()) {
      fetchContents();
    }
    checkAccess();
    setLoading(false);
  }, [API_BASE_URL, contents, customerId]);

  return (
    <>
      <SEO title="Content" />
      <Layout>
        <BreadcrumbOne
          title="The Easiest Way To Grow Business <br /> Everything in one place."
          rootUrl="/"
          parentUrl="Home"
          currentUrl="Content"
        />

        <div className="main-content">
          <div className="rn-blog-area rn-section-gap">
            <div className="container">
              {checkingAccess ? (
                <p className="text-center mt-5">Checking subscription...</p>
              ) : !hasAccess ? (
                <div className="text-center mt-5">
                  <h3>Your subscription has expired</h3>
                  <a href="/content" className="btn-default mt-3">Buy Content</a>
                </div>
              ) : loading && contents.length === 0 ? (
                <p>Loading...</p>
              ) : (
                <div className="row row--30">
                  <div className="col-lg-8">
                    <div className="row mt_dec--30">
                      <BlogProp column="col-lg-6 col-md-6 col-12 mt--30" data={contents} />
                    </div>
                  </div>
                  <div className="col-lg-4 mt_md--40 mt_sm--40">
                    <aside className="rwt-sidebar">
                      <div className="rbt-single-widget widget_search mt--40">
                        <div className="inner">
                          <form className="blog-search" action="#">
                            <input type="text" placeholder="Search ..." />
                            <button className="search-button">
                              <FaSistrix />
                            </button>
                          </form>
                        </div>
                      </div>
                      <div className="rbt-single-widget widget_categories mt--40">
                        <h3 className="title">Categories</h3>
                        <div className="inner">
                          <SideCategories data={contents} />
                        </div>
                      </div>
                      <div className="rbt-single-widget widget_tag_cloud mt--40">
                        <h3 className="title">Tags</h3>
                        <div className="inner mt--20">
                          <SidebarTag data={contents} />
                        </div>
                      </div>
                    </aside>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default BlogGridSidebar;
